import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Heart, Link2, Unlink, X } from "lucide-react";
import { Button } from "./ui/button";
import { API } from "../App";

export const CouplePartnerBadge = ({ patient, patients, onChanged }) => {
  const [editing, setEditing] = useState(false);
  const [choice, setChoice] = useState("");
  const [busy, setBusy] = useState(false);
  const partner = patients.find((p) => p.user_id === patient.couple_partner_id);
  const others = patients.filter((p) => p.user_id !== patient.user_id && p.is_active !== false).sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  const save = async (partnerId) => {
    setBusy(true);
    try {
      await axios.put(`${API}/therapist/patients/${patient.user_id}/partner`, { partner_id: partnerId }, { withCredentials: true });
      toast.success(partnerId ? "Partenaires liés" : "Lien de couple retiré");
      setEditing(false); setChoice("");
      onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setBusy(false); }
  };

  if (editing) {
    return (
      <div className="flex items-center gap-1.5 flex-wrap" data-testid="couple-partner-editor">
        <select className="text-sm rounded-lg border border-border bg-background px-2 py-1 max-w-[240px]" value={choice} onChange={(e) => setChoice(e.target.value)} data-testid="couple-partner-select">
          <option value="">Choisir le/la partenaire…</option>
          {others.map((p) => <option key={p.user_id} value={p.user_id}>{p.name}{p.email ? ` — ${p.email}` : ""}</option>)}
        </select>
        <Button size="sm" onClick={() => save(choice)} disabled={!choice || busy} data-testid="couple-partner-save">Lier</Button>
        <Button size="sm" variant="ghost" onClick={() => setEditing(false)} data-testid="couple-partner-cancel"><X className="w-4 h-4" /></Button>
      </div>
    );
  }
  if (partner) {
    return (
      <div className="flex items-center gap-1.5 flex-wrap" data-testid="couple-partner-badge">
        <Link to={`/therapist/patients/${partner.user_id}`} className="inline-flex items-center gap-1.5 rounded-full border border-rose-300 bg-rose-50 dark:bg-rose-950/30 px-2.5 py-0.5 text-xs font-medium text-rose-700 dark:text-rose-300 hover:bg-rose-100" data-testid="couple-partner-link">
          <Heart className="w-3 h-3" /> Couple avec {partner.name}
        </Link>
        <button onClick={() => save("")} disabled={busy} className="text-muted-foreground hover:text-destructive" title="Retirer le lien" data-testid="couple-partner-unlink"><Unlink className="w-3.5 h-3.5" /></button>
      </div>
    );
  }
  return (
    <button onClick={() => setEditing(true)} className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground" data-testid="couple-partner-add">
      <Link2 className="w-3 h-3" /> Lier à un·e partenaire (thérapie de couple)
    </button>
  );
};
